import { getCountryCodeFromPathname } from './getCountryCodeFromPathname'

export const getWordPressHost = () => {
  if (typeof window === 'undefined') return ''
  const countryCode = getCountryCodeFromPathname(window.location.pathname, 'TW')
  const isTW = countryCode === 'TW'
  return isTW ? `${window.location.origin}` : `${window.location.origin}/${countryCode.toLowerCase()}`
}
